class PagedList
/*:: <T>*/
{
  constructor(items
  /*: Array<T>*/
  , page
  /*: any*/
  = {}) {
    this.items = items;
    this.page = page;
  }

  copy(block
  /*: (Array<T>) => Array<T>*/
  = i => i)
  /*: PagedList<T>*/
  {
    return new PagedList(block(this.items), {
      next: this.page.next,
      prev: this.page.prev,
      current: this.page.current,
      max: this.page.max,
      helpers: this.page.helpers
    });
  }

}

module.exports = PagedList;